import React from 'react';
import styled from 'styled-components';
import { Question as QuestionObject } from '../../../commons/components/faq/faqObjects';
import { refWidth } from '../../utils/dimensions';
import { useFAQContext } from '../../../commons/components/faq/FAQProvider';
import { RollableWrapper } from '../../../commons/components/faq/RollableWrapper';
import { StyledHr } from '../../../commons/components/faq/StyledHr';
import HeaderWrapper from './HeaderWrapper';
import Answer from './Answer';

const Container = styled.div`
  margin-left: ${refWidth(30)}vw;
`;

interface Props {
  question: QuestionObject;
}

const Question = (props: Props) => {
  const { id, header, expanded, answers } = props.question;
  const { toggleQuestion } = useFAQContext();

  return (
    <Container>
      <StyledHr />
      <HeaderWrapper id={id} header={header} expanded={expanded} toggleAction={toggleQuestion} isQuestion={true} />
      <RollableWrapper expanded={expanded}>
        {answers.map((answer, index) => (
          <Answer key={index} answer={answer} />
        ))}
      </RollableWrapper>
    </Container>
  );
};

export default Question;
